import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { createElement } from "@wordpress/element";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * External dependencies
 */
import classnames from 'classnames';
/**
 * Internal dependencies
 */

import { HeaderUI } from './styles/card-styles';
import { useCardContext } from './context';
export var defaultProps = {
  isBorderless: false,
  isShady: false,
  size: 'medium'
};
export function CardHeader(props) {
  var className = props.className,
      isShady = props.isShady,
      additionalProps = _objectWithoutProperties(props, ["className", "isShady"]);

  var mergedProps = _objectSpread(_objectSpread(_objectSpread({}, defaultProps), useCardContext()), props);

  var isBorderless = mergedProps.isBorderless,
      size = mergedProps.size;
  var classes = classnames('components-card__header', isBorderless && 'is-borderless', isShady && 'is-shady', size && "is-size-".concat(size), className);
  return createElement(HeaderUI, _extends({}, additionalProps, {
    className: classes
  }));
}
export default CardHeader;
//# sourceMappingURL=header.js.map